module.exports = __webpack_public_path__ + "img/video_forbidden.5d13efa6.svg";